import { apiAuth, apiResponseType } from ".";

export const getGeofencesData = (
  page: number = 1,
  unity_id?: string,
  name?: string
): apiResponseType =>
  apiAuth.get(
    `geofences?page=${page}${unity_id ? `&unity_id=${unity_id}` : ""}${
      name ? `&name=${encodeURIComponent(name)}` : ""
    }`
  );

export const registerGeofencesData = (data) =>
  apiAuth.post("/geofences/store", data) as apiResponseType;

export const deleteGeofencesData = (uuid: string) =>
  apiAuth.delete(`geofences/${uuid}/destroy`) as apiResponseType;

export const updateGeofencesData = (uuid: string, data) =>
  apiAuth.post(`geofences/${uuid}/update`, data) as apiResponseType;

export const getShowGeofences = (uuid: string) =>
  apiAuth.get(`geofences/${uuid}/show`) as apiResponseType;

export const searchGeofencesData = (params: {
  name: string;
  unity_id?: string;
}): apiResponseType =>
  apiAuth.get(
    `geofences?name=${params.name}${
      params.unity_id ? `&unity_id=${params.unity_id}` : ""
    }`
  );

export const setStatusGeofences = (uuid: string) =>
  apiAuth.put(`geofences/${uuid}/toggle-status`) as apiResponseType;

export const getSelectGeofences = () =>
  apiAuth.get(`geofences/select`) as apiResponseType;
